import React from 'react';
import SelectIndex from '../../form/select/index';
import getData from './data';

class Country extends React.Component{
    constructor(props){
        super(props);
        this.state = {};
    }
    componentWillMount(){
        getData(({country={}, province={}, city = {}, district={}})=>{
            this.setState({
                options: country.options
            });
        });
    }
    render(){
        let options= this.state.options || [];
        return (
            <SelectIndex {...this.props} options={options}/>
        )
    }
    
}

export default Country;


// WEBPACK FOOTER //
// ./src/component/AddressOld/Country.js